import { customerApi } from "../../utils/apiConfig";
/**
 * EXPORT ORDER
 */

export const insertExportOrder = (payload) => {
  return customerApi.post("/insertExportOrder", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getExportOrderList = (payload = {}) => {
  return customerApi.post("/getExportOrderList", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getExportOrderDetail = (payload) => {
  return customerApi.post("/getExportOrderDetail", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateExportOrder = (payload) => {
  return customerApi.post("/updateExportOrder", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteExportOrder = (payload) => {
  return customerApi.post("/deleteExportOrder", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

/**
 * EXPORT ORDER ITEM
 */

export const insertExportOrderItem = (payload) => {
  return customerApi.post("/insertExportOrderItem", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getExportOrderItemList = (payload) => {
  return customerApi.post("/getExportOrderItemList", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const updateExportOrderItem = (payload) => {
  return customerApi.post("/updateExportOrderItem", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const deleteExportOrderItem = (payload) => {
  return customerApi.post("/deleteExportOrderItem", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getCustomerExportAnalysis = (customerId) => {
  const endpoint = customerId
    ? `/getCustomerExportAnalysis/${customerId}`
    : `/getCustomerExportAnalysis`;

  return customerApi.get(
    endpoint,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  );
};
